import script from "./Variations.vue?vue&type=script&lang=ts&setup=true"
export * from "./Variations.vue?vue&type=script&lang=ts&setup=true"

import "./Variations.vue?vue&type=style&index=0&id=4fbdbd7d&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fbdbd7d"]])

export default __exports__